import React from 'react';
import s from "../../assets/images/sussd-chars/s.svg"
import u from "../../assets/images/sussd-chars/u.svg"
import d from "../../assets/images/sussd-chars/d.svg"
import apos from "../../assets/images/sussd-chars/apos.svg"
function SettingThingsUp(props) {
    return (
        <div className="d-flex align-items-center vh-100">
            <div className="sussd-bounce">
                <img className="char1" src={s} alt="S"/>
                <img className="char2" src={u} alt="U"/>
                <img className="char3" src={s} alt="S"/>
                <img className="char4" src={s} alt="S"/>
                <img className="char5" src={apos} alt="&apos;"/>
                <img className="char6" src={d} alt="D"/>
            </div>
        </div>

    );
}

export default SettingThingsUp;

